/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Overwrite_Cancelled_ErrorInputs */

const en_explorer_thumbnail_overwrite_cancelled_error = /** @type {(inputs: Explorer_Thumbnail_Overwrite_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwriting project was cancelled`)
};

const fr_explorer_thumbnail_overwrite_cancelled_error = /** @type {(inputs: Explorer_Thumbnail_Overwrite_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ecrasement du projet annule`)
};

const de_explorer_thumbnail_overwrite_cancelled_error = /** @type {(inputs: Explorer_Thumbnail_Overwrite_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Überschreibungsprojekt wurde abgebrochen.`)
};

const it_explorer_thumbnail_overwrite_cancelled_error = /** @type {(inputs: Explorer_Thumbnail_Overwrite_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il progetto di sovrascrittura è stato annullato`)
};

const ru_explorer_thumbnail_overwrite_cancelled_error = /** @type {(inputs: Explorer_Thumbnail_Overwrite_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект по перезаписи был отменен.`)
};

const es_explorer_thumbnail_overwrite_cancelled_error = /** @type {(inputs: Explorer_Thumbnail_Overwrite_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se canceló el proyecto de sobrescritura`)
};

const zh_cn2_explorer_thumbnail_overwrite_cancelled_error = /** @type {(inputs: Explorer_Thumbnail_Overwrite_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`覆盖项目已取消`)
};

const ja_explorer_thumbnail_overwrite_cancelled_error = /** @type {(inputs: Explorer_Thumbnail_Overwrite_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上書きプロジェクトはキャンセルされました`)
};

const hi_explorer_thumbnail_overwrite_cancelled_error = /** @type {(inputs: Explorer_Thumbnail_Overwrite_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओवरराइटिंग परियोजना रद्द कर दी गई।`)
};

const pt_pt2_explorer_thumbnail_overwrite_cancelled_error = /** @type {(inputs: Explorer_Thumbnail_Overwrite_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O projeto de sobrescrita foi cancelado.`)
};

/**
* | output |
* | --- |
* | "Overwriting project was cancelled" |
*
* @param {Explorer_Thumbnail_Overwrite_Cancelled_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_overwrite_cancelled_error = /** @type {((inputs?: Explorer_Thumbnail_Overwrite_Cancelled_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Overwrite_Cancelled_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_overwrite_cancelled_error(inputs)
	if (locale === "de") return de_explorer_thumbnail_overwrite_cancelled_error(inputs)
	if (locale === "it") return it_explorer_thumbnail_overwrite_cancelled_error(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_overwrite_cancelled_error(inputs)
	if (locale === "es") return es_explorer_thumbnail_overwrite_cancelled_error(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_overwrite_cancelled_error(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_overwrite_cancelled_error(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_overwrite_cancelled_error(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_overwrite_cancelled_error(inputs)
	return en_explorer_thumbnail_overwrite_cancelled_error(inputs)
});